import {
  FETCH_LOCATION,
  FETCH_LOCATION_SUCCESS,
  FETCH_LOCATION_FAILS,
  FETCH_LOCATION_DETAILS,
  FETCH_LOCATION_DETAILS_SUCCESS,
  FETCH_LOCATION_DETAILS_FAILS
} from './locationActionTypes';

export const locationReducer = (
  state = {
    places: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    locationDetails: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    }
  },
  action
) => {
  switch (action.type) {
    case FETCH_LOCATION:
      return {
        ...state,
        places: {
          ...state.places,
          fetching: true,
          error: { status: false, message: '' },
          data: state.places?.data || []
        }
      };

    case FETCH_LOCATION_SUCCESS:
      return {
        ...state,
        places: {
          ...state.places,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload?.predictions || []
        }
      };

    case FETCH_LOCATION_FAILS:
      return {
        ...state,
        places: {
          ...state.places,
          fetching: false,
          error: { status: true, message: action.payload },
          data: state.places?.data || []
        }
      };

    //;;;
    case FETCH_LOCATION_DETAILS:
      return {
        ...state,
        locationDetails: {
          ...state.locationDetails,
          fetching: true,
          error: { status: false, message: '' },
          data: state.locationDetails?.data || []
        }
      };

    case FETCH_LOCATION_DETAILS_SUCCESS:
      return {
        ...state,
        locationDetails: {
          ...state.locationDetails,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload || []
        }
      };

    case FETCH_LOCATION_DETAILS_FAILS:
      return {
        ...state,
        locationDetails: {
          ...state.locationDetails,
          fetching: false,
          error: { status: true, message: action.payload },
          data: state.locationDetails?.data || []
        }
      };

    default:
      return state;
  }
};
